import { gql } from '@apollo/client'
import { POST_CARD_FIELDS } from '../fragments/postCardFields'

export const GET_POST = gql`
  query GetPost($id: ID!) {
    post(id: $id) {
      ...PostCardFields
      status
      editable
      channel {
        id
        viewerIsOwner
      }
    }
  }
  ${POST_CARD_FIELDS}
`
